import {IoDocuments, IoShieldCheckmark} from "react-icons/io5";
import {
    MdBarChart,
    MdCreateNewFolder,
    MdDashboard, MdDevices,
    MdDevicesOther,
    MdMobileFriendly,
    MdMobileOff
} from "react-icons/md";
import React, {useEffect, useState} from "react";
import {AES, enc} from 'crypto-js';
import axios from "axios";
import moment from "moment";

import Widget from "components/widget/Widget";
import {useUserAuth} from "../../../context/UserAuthContext";
import {useNavigate} from "react-router-dom";
import useAsyncEffect from "use-async-effect";
import ActivatedDevicesTrendGraph from "./components/ActivatedDevicesTrendGraph";
import InActiveDevicesTrendGraph from "./components/InActiveDevicesTrendGraph";
import CategoriesDistributionGraph from "./components/CategoriesDistributionGraph";
import ExecutedSchedulesPerProductGraph from "./components/ExecutedSchedulesPerProductGraph";
import FirmwareAnalyticsGraph from "./components/FIrmwareDeviceAnalytics";
import UserWithDeviceCount from "./components/UsersWithDeviceCount";
import ExecutedSchedulesMonthlyTrend from "./components/ExecutedSchedulesMonthlyTrend";
import ProductRatingTrendGraph from "./components/ProductRatingTrendGraph";
import Alerts from "../error";
import EnergySavingsStatisticsGraph from "./components/EnergySavingStatisticsGraph";
import EnergyConsumptionStatisticsGraph from "./components/EnergyConsumptionStatisticsGraph";
import EnergySavingsState from "./components/EnergySavingsState";
import EnergyConsumptionState from "./components/EnergyConsumptionState";
import RunTimeStatistics from "./components/RunTimeStatistics";

const Dashboard = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    var sv = "";
    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    const [summaryValues, setSummaryValues] = useState(["--"]);
    const [summaryNumberValues, setSummaryNumberValues] = useState(["--"]);

    var stats = [];
    var statsNumber = [];

    /*window.addEventListener("storage", (event) => {
        if (event.key === "auth:event") {
            const data = JSON.parse(event.newValue || "{}");

            if (data.type === "LOGOUT") {
                window.location.href = "/senze-2.0";
            }
        }
    });*/

    const monthsmap = new Map([["01", "Jan"], ["02", "Feb"], ["03", "Mar"], ["04", "Apr"], ["05", "May"], ["06", "Jun"], ["07", "Jul"], ["08", "Aug"], ["09", "Sep"], ["10", "Oct"], ["11", "Nov"], ["12", "Dec"],]);
    const [message, setErrorMessage] = useState("");

    const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()
    const addMonths = (input, months) => {
        const date = new Date(input)
        date.setDate(1)
        date.setMonth(date.getMonth() + months)
        date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth() + 1)))
        return date.toISOString().slice(0, 10)
    }

    function formatDateForApi(date) {
        var d = date.split("-");
        var y = d[0]
        var m = d[1]
        var da = d[2]
        date = da + "-" + m + "-" + y
        ////console.log(date)
        return date
    }

    const [LowerDate, setLowerDate] = useState(addMonths(new Date(new Date().toISOString().slice(0, 10)), -11));
    const [UpperDate, setUpperDate] = useState(new Date().toISOString().slice(0, 10));

    function handleStartDateChange(lowerDate) {
        setLowerDate(lowerDate)
        sessionStorage.setItem("startDate", lowerDate)
    }

    function handleEndDateChange(upperDate) {
        setUpperDate(upperDate)
        sessionStorage.setItem("endDate", upperDate)
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    const handleIncreaseDate = (currentDate) => {
        const newDate = moment(currentDate, 'DD-MM-YYYY').add(1, 'days');
        currentDate = newDate.format('DD-MM-YYYY')
        //console.log("CURRENT DATE: ", currentDate)
        return currentDate
    };

    useAsyncEffect(async () => {

        async function getOverallSummary() {
            if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "5")) {
                var url = CROMPTON_ANALYTICS_URL + "v1/user/statistics"

                let analyticsSummary = JSON.parse(sessionStorage.getItem("AnalyticsSummary"))
                //console.log(analyticsSummary)
                for (var i in analyticsSummary) {
                    stats.push(i);
                    statsNumber.push(analyticsSummary[i])
                }
                setSummaryValues(stats);
                setSummaryNumberValues(statsNumber);


                /*axios({
                    method: "GET", url: url, headers: {
                        Authorization: decryptedValue,
                    }

                }).then((res) => {
                    //console.log(res.data)
                    for (var i in res.data) {
                        stats.push(i);
                        statsNumber.push(res.data[i])
                    }
                    setSummaryValues(stats);
                    setSummaryNumberValues(statsNumber);
                    //getMonthlyRegisteredUsersTrend()


                }).catch((error) => {
                    if (error.response.data.status === "401" || error.response.data.status === "403") {
                        handleLogOut();
                    }
                })*/

            } else {
                //console.log("Inside stats non admin")
                setErrorMessage("You do not have permission to view this. Please contact admin.")
            }
        }

        function getProductCatalog() {
            if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "5")) {
                var chartLabels = [];
                var count = [];
                var url = CROMPTON_ANALYTICS_URL + "v1/device/products"
                axios({
                    method: "GET", url: url, headers: {
                        Authorization: decryptedValue,
                    }

                }).then((res) => {
                    //console.log(res.data)
                    for (var i in res.data) {
                        chartLabels.push((res.data[i].productId))
                        count.push(res.data[i].product)
                    }

                    sessionStorage.setItem("productCatalogArray", JSON.stringify(res.data))

                    /*localStorage.setItem("productId", JSON.stringify(chartLabels))
                    localStorage.setItem("productNames", JSON.stringify(count))*/

                    //getDevicesPerProduct()

                    /*console.log("Data labels: ", chartLabels)
                    console.log("Data values: ", count)*/

                }).catch((error) => {
                    //console.log(error)
                    if (error.response.data.status === "401" || error.response.data.status === "403") {
                        handleLogOut();
                    }
                })

            } else {
                //console.log("Inside stats non admin")
                setErrorMessage("You do not have permission to view this. Please contact admin.")
            }
        }

        await getOverallSummary()

        //getProductCatalog()

    }, [sv]);


    return (
        <div>
            {/* Card widget */}

            {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || (accesscontrollevel.toString() === "5")?

                <div
                    className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-3">
                    <Widget
                        icon={<MdDevices className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                        title={"Total Activated Devices"}
                        subtitle={summaryNumberValues[3] + "*"}
                        percentage={summaryNumberValues[9]}
                    />
                    <Widget
                        icon={<IoShieldCheckmark className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                        title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Active Devices"}
                        subtitle={summaryNumberValues[5]}
                        percentage={summaryNumberValues[11]}
                    />
                    <Widget
                        icon={<MdMobileFriendly className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                        title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Activated"}
                        subtitle={summaryNumberValues[4]}
                        percentage={summaryNumberValues[10]}
                    />
                    {/*<Widget
                    icon={<MdDashboard className="h-6 w-6"/>}
                    title={"Total Activated Devices"}
                    subtitle={summaryNumberValues[3] + "*"}
                />
                <Widget
                    icon={<MdBarChart className="h-7 w-7"/>}
                    title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Active Devices"}
                    subtitle={summaryNumberValues[5]}
                />
                <Widget
                    icon={<IoMdHome className="h-6 w-6"/>}
                    title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Activated"}
                    subtitle={summaryNumberValues[4]}
                />*/}
                </div>
                :
                <div
                    className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-3">
                    <Widget
                        icon={<MdDevices className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                        title={"Total Activated Devices"}
                        subtitle={"--"}
                        percentage={"--"}
                    />
                    <Widget
                        icon={<IoShieldCheckmark className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                        title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Active Devices"}
                        subtitle={"--"}
                        percentage={"--"}
                    />
                    <Widget
                        icon={<MdMobileFriendly className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                        title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Activated"}
                        subtitle={"--"}
                        percentage={"--"}
                    />
                    {/*<Widget
                    icon={<MdDashboard className="h-6 w-6"/>}
                    title={"Total Activated Devices"}
                    subtitle={summaryNumberValues[3] + "*"}
                />
                <Widget
                    icon={<MdBarChart className="h-7 w-7"/>}
                    title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Active Devices"}
                    subtitle={summaryNumberValues[5]}
                />
                <Widget
                    icon={<IoMdHome className="h-6 w-6"/>}
                    title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Activated"}
                    subtitle={summaryNumberValues[4]}
                />*/}
                </div>
            }

            {/* Charts */}

            <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                {accesscontrollevel.toString() === "1"  || accesscontrollevel.toString() === "5"?
                    <ActivatedDevicesTrendGraph/> : <Alerts/>
                }
                {accesscontrollevel.toString() === "1"  || accesscontrollevel.toString() === "5"?
                    <InActiveDevicesTrendGraph/> : <Alerts/>
                }
            </div>

            {/* Tables & Charts */}

            <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
                {/*  Check Table*/}
                <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
                    {accesscontrollevel.toString() === "1" || (accesscontrollevel.toString() === "5")?
                        <ExecutedSchedulesPerProductGraph/> : <Alerts/>
                    }
                    {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || (accesscontrollevel.toString() === "5")?
                        <UserWithDeviceCount/> : <Alerts/>}
                </div>

                {/* Traffic chart & Pie Chart*/}

                <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
                    {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "2" || (accesscontrollevel.toString() === "5")?
                        <FirmwareAnalyticsGraph/> : <Alerts/>}
                    {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "2" || (accesscontrollevel.toString() === "5")?
                        <CategoriesDistributionGraph/> : <Alerts/>}
                </div>

                {accesscontrollevel.toString() === "1" || (accesscontrollevel.toString() === "5")?
                    <ExecutedSchedulesMonthlyTrend/> : <Alerts/>}

                {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "2" || (accesscontrollevel.toString() === "5")?
                    <ProductRatingTrendGraph/> : <Alerts/>}
                {/*<div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
                    <CheckTable
                        columnsData={columnsDataCheck}
                        tableData={tableDataCheck}
                    />
                    <FirmwareAnalyticsGraph/>
                </div>*/}

                {/* Complex Table , Task & Calendar*/}

                {/*<ComplexTable
                    columnsData={columnsDataComplex}
                    tableData={tableDataComplex}
                />*/}

                {/*Task chart & Calendar*/}

                {/*<div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
                    <TaskCard/>
                    <div className="grid grid-cols-1 rounded-[20px]">
                        <MiniCalendar/>
                    </div>
                </div>*/}
            </div>

            <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                {/*<div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">*/}
                {accesscontrollevel.toString() === "1" || (accesscontrollevel.toString() === "5")?
                    <EnergySavingsStatisticsGraph/> : <Alerts/>
                }
                {accesscontrollevel.toString() === "1" || (accesscontrollevel.toString() === "5")?
                    <EnergyConsumptionStatisticsGraph/> : <Alerts/>
                }
                {/* </div>*/}

            </div>

            <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                {/*<div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">*/}
                {accesscontrollevel.toString() === "1" || (accesscontrollevel.toString() === "5")?
                    <EnergySavingsState/> : <Alerts/>
                }
                {accesscontrollevel.toString() === "1" || (accesscontrollevel.toString() === "5")?
                    <RunTimeStatistics/> : <Alerts/>
                }
                {/* </div>*/}

            </div>

            {/*<div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
                {accesscontrollevel.toString() === "1" ?
                    <RunTimeStatistics/> : <Alerts/>
                }
                {accesscontrollevel.toString() === "1" ?
                    <EnergyConsumptionState/> : <Alerts/>
                }
                 </div>

            </div>*/}
        </div>
    );
};

export default Dashboard;
